<ion-row *transloco="let t">
  <ion-col size="6" class="text-align-bottom">
    <div class="table-label-text">
      <ion-label>{{ labelText }}</ion-label>
    </div>
  </ion-col>

  <ion-col size="6">
    <div class="ion-text-end table-control-config">
      <div *ngIf="showToggle" class="table-config-toggle">
        <ion-label>{{ t('showActiveLabel') }}</ion-label>
        <ion-toggle
          [(ngModel)]="active"
          mode="ios"
          (click)="onToggle($event)"
        ></ion-toggle>
      </div>

      <ion-button
        (click)="onEditColumns()"
        class="table-config-button"
        color="secondary"
        shape="round"
        fill="outline"
      >
        <span class="table-config-button-icon">
          <ion-icon slot="icon-only" name="settings"></ion-icon>
        </span>
      </ion-button>
    </div>
  </ion-col>
</ion-row>
